export const PROJECT_TYPES = [
  // {
  //   value: 1,
  //   label: '小说标注',
  // },
  {
    value: 2,
    label: '人工创建',
  },
];

export const APP_LIST_MAP: any = {
  1: 'CAI技术中台',
  2: 'MirAI',
  3: '腾讯视频',
};

export const APP_LIST = Object.keys(APP_LIST_MAP).map((key: any) => ({
  value: Number(key),
  label: APP_LIST_MAP[key],
}));

export const actionBtnTypeMap = {
  caidataMarker: 1, // 系统内自主生产者，使用新增语料和导入语料
  caiOuterMarker: 2,
  caiWriteMarker: 3,
  caiHistoryBadMarker: 4, // cai历史语料badcase修改
  caiHistoryNormalMarker: 5, // cai历史语料正常语料修改
};

// 语料来源类型
export const QA_SOURCE_TYPE_MAP: any = {
  [actionBtnTypeMap.caiOuterMarker]: 'CAI修改语料',
  [actionBtnTypeMap.caiWriteMarker]: 'CAI创作语料',
  [actionBtnTypeMap.caiHistoryBadMarker]: '用户反馈差评语料',
  [actionBtnTypeMap.caiHistoryNormalMarker]: '用户全量历史语料',
  [actionBtnTypeMap.caidataMarker]: '自主生产',
};

export const QA_SOURCE_TYPE_LIST = Object.keys(QA_SOURCE_TYPE_MAP).map((key: any) => ({
  value: Number(key),
  label: QA_SOURCE_TYPE_MAP[key],
}));

export const QA_TASK_STATUS_MAP = {
  no_valid: 0, // 未生效，项目未提交
  to_do_task: 1, // 已提交项目，待标注
  doing_task: 2, // 标注中，保存草稿，待提交
  to_review_task: 3, // 已提交标注任务，待质检
  to_sampling_task: 4, // 已提交质检任务，待抽样
  to_check_task: 5, // 已提交质检任务，待验收
  checked_task: 6, // 已验收
};

export const TASK_INFO_COLOUMN_MAP = {
  status: {
    nameZH: '状态',
    type: 'select',
    options: {
      [QA_TASK_STATUS_MAP.no_valid]: '未生效',
      [QA_TASK_STATUS_MAP.to_do_task]: '待标注',
      [QA_TASK_STATUS_MAP.doing_task]: '草稿中',
      [QA_TASK_STATUS_MAP.to_review_task]: '待质检',
      [QA_TASK_STATUS_MAP.to_sampling_task]: '待抽样',
      [QA_TASK_STATUS_MAP.to_check_task]: '待验收',
      [QA_TASK_STATUS_MAP.checked_task]: '验收完成',
    },
    color: ['#f5222d', '#1890ff', '#cc0066', '#ff9900', '#1e81b0', '#1a1ae2', '#52c41a'],
  },
  type: {
    nameZH: '项目类型',
    type: 'select',
    options: {
      1: '小说标注',
      2: '人工创建',
    },
  },
};

export const BOT_INFO_COLOUMN_MAP = {
  app_id: {
    nameZH: '产品空间',
    type: 'select',
    options: APP_LIST_MAP,
  },
};

export const QA_INFO_COLOUMN_MAP = {
  status: {
    nameZH: '状态',
    type: 'select',
    options: {
      0: '待审批',
      1: '未通过',
      2: '已通过',
    },
    color: ['#1a1ae2', '#f5222d', '#52c41a'],
  },
};

export const IS_VALID_STATUS_COLOUMN_MAP = {
  status: {
    nameZH: '状态',
    type: 'select',
    options: {
      0: '已失效',
      1: '生效中',
    },
    color: ['#f5222d', '#52c41a'],
  },
};

export const getQQDomianStatus = (optionsKeys: number[] = []) => {
  const options = TASK_INFO_COLOUMN_MAP['status'].options;
  const newOpt: any = {};
  optionsKeys.map((key) => {
    newOpt[key] = options[key];
  });
  const data = {
    ...TASK_INFO_COLOUMN_MAP,
    status: {
      ...TASK_INFO_COLOUMN_MAP['status'],
      options: newOpt,
    },
  };
  return data;
};
export const TOPIC_TYPE_OBJ = {
  new: {
    value: 0,
    label: '新增会话',
  },
  old: {
    value: 1,
    label: '选择已有会话',
  },
};

export const QA_STATUS_OBJ = {
  new: {
    value: 0,
    label: '不通过',
  },
  old: {
    value: 1,
    label: '通过',
  },
};

// export const TASK_REVIEW_USERS = [
//   {
//     value: 'bostinshi',
//     label: 'bostinshi（史波）',
//   },
//   {
//     value: 'jiangyinsu',
//     label: 'jiangyinsu（苏江吟）',
//   },
//   {
//     value: 'henrysxu',
//     label: 'henrysxu（徐羽）',
//   },
//   {
//     value: 'kianaziyili',
//     label: 'kianaziyili（李子怡）',
//   },
// ];

// export const TASK_SAMPLING_USERS = [
//   {
//     value: 'bostinshi',
//     label: 'bostinshi（史波）',
//   },
//   {
//     value: 'jiangyinsu',
//     label: 'jiangyinsu（苏江吟）',
//   },
//   {
//     value: 'henrysxu',
//     label: 'henrysxu（徐羽）',
//   },
//   {
//     value: 'kianaziyili',
//     label: 'kianaziyili（李子怡）',
//   },
// ];

// export const TASK_CHECK_USERS = [
//   {
//     value: 'bostinshi',
//     label: 'bostinshi（史波）',
//   },
//   {
//     value: 'jiangyinsu',
//     label: 'jiangyinsu（苏江吟）',
//   },
//   {
//     value: 'henrysxu',
//     label: 'henrysxu（徐羽）',
//   },
//   {
//     value: 'kianaziyili',
//     label: 'kianaziyili（李子怡）',
//   },
// ];
// 语料生产任务的上一个角色字段
export const QA_TASK_LAST_ROLE_MAP = {
  create: 0,
  mark: 1,
  review: 2,
  smapling: 3,
  check: 4,
};

// 页面权限map
export const ADMIN_AUTH_MAP = {
  operator: 0, // 普通操作员-不可配置无极
  admin: 1, // 管理员-可配置无极
  caiOuterMarker: 2, // cai外包-展示cai标注修改按钮
  caiWriteMarker: 3, // cai写手-展示cai标注创作按钮
};

export interface TopicItem {
  source_type: number;
  session_id: string;
  session_name: string;
  qa_list: Item[];
  session_ext: any;
}
export interface Item {
  [x: string]: any;
  status: any;
  key: string;
  question: string;
  answer: string;
}

export const Default_Bot_Rule = '1. 需要参照人设中的简短和详细描述，以符合其语气、行为、身份的方式来构建语料。';
